export default __webpack_public_path__ + "a27ee305f83c364e55903e8fd3b389a5.png";